import React from "react";
import { Button, Table, Textfield } from "../../../../components/core";
import { NumberFormatBase } from "react-number-format";
import { InputNumber } from "primereact/inputnumber";

export default function OverstayCharge({
	data,
	handleChange,
	header,
	disabled = false,
}) {
	return (
		<div className="w-full">
			<div className="bg-primary-primaryYellow w-2/3 mt-4 p-4 text-center border-secondary-buttonHeaderGray border-2">
				<p className="font-bold text-xl">Overstay Charges after</p>
				<p>{header}</p>
			</div>
			<div className="flex gap-3 w-2/3 border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2 justify-center">
				{/* <p className="my-auto">P</p> */}
				<Textfield
					disabled={disabled}
					className={"h-10 border-2 focus:outline-yellow-400 rounded-md p-1"}
					value={data.excessFeePerInc}
					prefix={"P"}
					name="excessFeePerInc"
					onChange={(e) => {
						var numberPattern = /^\d+(\.\d{0,2})?$/; // Allowing up to 2 decimal places
						console.log(
							numberPattern.test(e.target.value) || e.target.value === ""
						);
						if (numberPattern.test(e.target.value) || e.target.value === "") {
							if (
								parseFloat(e.target.value) <= 1000000000 ||
								e.target.value === ""
							) {
								handleChange(e);
							}
						}
					}}
				/>
				<p className="my-auto">/ every</p>
				<Textfield
					disabled={disabled}
					className={"h-10 border-2 focus:outline-yellow-400 rounded-md p-1"}
					value={data.incByHours}
					name="incByHours"
					onChange={(e) => {
						var numberPattern = /^(\d+)?$/;

						if (
							numberPattern.test(e.target.value) &&
							(parseFloat(e.target.value) <= 720 || e.target.value === "")
						) {
							handleChange(e);
						}
					}}
				/>
				<p className="my-auto">hrs</p>
			</div>
		</div>
	);
}
